module.exports = Em.Object.extend({
    icon: null,

    tip: null,

    click: null,

    dataCy: null
})
